import { createSlice } from "@reduxjs/toolkit"
import { GetReservacionesTableQuery, Habitacion } from "src/gql/schema"

export interface reservationsState {
    selectedReservation?: GetReservacionesTableQuery["reservas"][0]
    drawerSelectedSection: "detail" | "rooms" | "payments" | "selectedRoomToAssignReservation"
    selectedRoom?: Habitacion
}

const initialState: reservationsState = {
    selectedReservation: undefined,
    drawerSelectedSection: "detail",
}

export const reservationsSlice = createSlice({
    name: "reservations",
    initialState,
    reducers: {
        selectReservation: (state, action) => {
            state.selectedReservation = action.payload
        },
        selectDrawerSection: (state, action: {payload: "detail" | "rooms" | "payments" | "selectedRoomToAssignReservation", type: string}) => {
            state.drawerSelectedSection = action.payload
        },
        selectRoom: (state, action) => {
            state.selectedRoom = action.payload
        },
    },
})

export const { selectReservation, selectDrawerSection, selectRoom } = reservationsSlice.actions

export default reservationsSlice.reducer
